import { Link } from 'react-router-dom';

/**
 * Props that render a MUI Button as a router link (a single <a> element),
 * instead of nesting a <button> inside an <a>. Usage: <Button {...linkTo('/contact')}>.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const linkTo = (to: string): any => ({ component: Link, to });
